module.exports = __webpack_public_path__ + "static/media/angle-double-up.93141a36.svg";